import _classCallCheck from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import React, { PureComponent } from "react";
//Material imports
import Avatar from "@material-ui/core/Avatar";

var UserAvatar = /*#__PURE__*/function (_PureComponent) {
  _inherits(UserAvatar, _PureComponent);

  var _super = _createSuper(UserAvatar);

  function UserAvatar() {
    _classCallCheck(this, UserAvatar);

    return _super.apply(this, arguments);
  }

  _createClass(UserAvatar, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          author = _this$props.author,
          thumbnail = _this$props.thumbnail,
          avatarClassName = _this$props.avatarClassName;

      if (thumbnail) {
        return /*#__PURE__*/React.createElement(Avatar, {
          src: "data:image/png;base64, ".concat(thumbnail),
          alt: author,
          className: avatarClassName || ""
        });
      }

      return /*#__PURE__*/React.createElement(Avatar, null, author ? author.charAt(0).toUpperCase() : "L");
    }
  }]);

  return UserAvatar;
}(PureComponent);

export default UserAvatar;